var $ = jQuery.noConflict();

$(function(){


    $('.fdp-current-country').on('click', function() {
        const $parent = $(this).parent(); // Store the parent element in a variable
        $parent.toggleClass('active');
    
        setTimeout(() => {
            $parent.toggleClass('animation-active'); // Use the stored parent element
        }, 50);
    });
  


    $fdpMainSldier = $('.custom-slideshow-wrapper .custom-slideshow');

    $fdpMainSldier.on('init', function(event, slick, direction){

        //$('.slick-active').addClass('first-slide');        

        setTimeout(function() {
             $('.slick-active').addClass('animation-active2');           
          }, 5); 

        setTimeout(function() {
           /* 
            if ( $('.slick-active').hasClass('first-slide')  ) {

            } else {
                $('.slick-active').addClass('animation-active');           
            }
*/
            $('.slick-active').addClass('animation-active');           

        }, 125); 

     //console.log('init1')
        

    })

    $fdpMainSldier.each(function () {
        var self = $(this),
            dataArrows = self.data('arrows'),
            dataDots = self.data('dots'),
            autoplay = self.data('autoplay'),
            autoplaySpeed = self.data('autoplay-speed')
  


            self.slick({
        dots: true,
        //infinite: true,
        autoplay: self.data('autoplay'),
        autoplaySpeed: self.data('autoplay-speed'),
        //arrows: self.data('arrows'),
        speed: 500,
        slidesToShow: 1,
        pauseOnHover: true,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
            {
              breakpoint: 820,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });



      $fdpMainSldier.on('swipe', function(event, slick, direction){
        //console.log(direction);
        // left
        });

        // On edge hit
        $fdpMainSldier.on('edge', function(event, slick, direction){
        //console.log('edge was hit')
        });

        // On before slide change
        $fdpMainSldier.on('beforeChange', function(event, slick, currentSlide, nextSlide){

          //  console.log('beforeChange/init', event, slick, slick.$slides);

           // console.log(nextSlide);
           // console.log( $(this) );
           
          
            
        });

        $fdpMainSldier.on('afterChange init', function(event, slick, direction){
            //console.log('afterChange/init', event, slick, slick.$slides);
            // remove all prev/next
            //slick.$slides.removeClass('prevdiv').removeClass('nextdiv');

            // find current slide
            for (var i = 0; i < slick.$slides.length; i++)
            {
                var $slide = $(slick.$slides[i]);
                if ($slide.hasClass('slick-current')) {
                    // update DOM siblings
                    //$slide.prev().addClass('prevdiv');
                    $slide.prev().addClass('load-images');
                    $slide.next().addClass('load-images');

                    $slide.addClass('load-images');
                    //$('.slick-slide').removeClass('first-slide');
                    $('.item > div').removeClass('first-slide');

                    break;
                }
            }

            setTimeout(function() {
            
                $('.slick-active').addClass('animation-active2');           

            }, 5); 


            setTimeout(function() {
            
                $('.slick-active').addClass('animation-active');           

            }, 125); 

             
        }); // $fdpMainSldier

        

    $fdpMainSldier.on('beforeChange', function(event, slick) {
        $('.slick-slide').removeClass('animation-active');  
        $('.slick-slide').removeClass('animation-active2');  
    })


});



    //$('.rbr-mbap_item_info .pl-swatches-collection').remove();
    
	
    // Add fixed-header class
	if ( ! $('body').hasClass('checkout') ) {
	 
		/* Sticky menu	*/
		var $document3 = $(document),
			$element3 = $('body'),
			className3 = 'fixed-header';

		$document3.scroll(function() {
		  $element3.toggleClass(className3, $document3.scrollTop() >= 240);	  
		});	
			
	}

    
      // Load Category Icons in Menu - on mouseover
	$('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {	
		$(this).addClass('menu-icons-active');	
	});



    function sg9ClickableDropdownMenuDesktop() {

        var documentWidth = $(document).width();

  
    
        if (documentWidth > 1024) {
            
          

            // Touch Screen Menu Level 1 Dropdown
            $('.menu-lv-1.has-megamenu.dropdown > span[aria-label="Drop Down Menu"]').on('click', function() {	
                    
                if ( $(this).hasClass('menu-dropdown-active')  ) {
                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
                    $(this).removeClass('menu-dropdown-active');	
                    //$(this).closest('.menu-lv-1').removeClass('menu-dropdown-active');

                } else {
                    
                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	

                    $(this).addClass('menu-dropdown-active');	
                    $(this).closest('.menu-lv-1').addClass('menu-icons-active');

                }

            });

              // Touch Screen Menu Level 1 Dropdown
              $('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {	
                    
                $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
                //$('.menu-lv-1').removeClass('menu-dropdown-active');                

            });

        } else {

            $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
           //$('.menu-lv-1').removeClass('menu-dropdown-active');

        }

 
    
    }; // sg9ClickableDropdownMenuDesktop()

    sg9ClickableDropdownMenuDesktop(); 


 
 

    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {
	   
	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;
            
            sg9ClickableDropdownMenuDesktop();

            sg9ExpandProductSpecifications();
            //sgAddMenuItem();
				   
		}           
		
	} // resizeend()



    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .pl-swatches-collection').remove();
    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .card-action').remove();
        



    
    function sg9ExpandProductSpecifications() {
        
        if ( $('body').hasClass('template-product') ) { 

            //var documentWidth = $(document).width();        
            var documentWidth = $(window).outerWidth();        
            //var documentWidth = $(window).width();        
            
            // Remove any existing click handlers to prevent stacking
            $('.product-specifications-title').off('click');
            
            // Handle visibility and click functionality based on width
            if (documentWidth > 550) {                
                $('#product-specifications').show();
                $('.product-specifications-title').attr('aria-expanded', true).addClass('expand');
            } else {
                $('#product-specifications').hide();
                $('.product-specifications-title').attr('aria-expanded', false).removeClass('expand');
                
                // Only set up click handler for mobile view
                $('.product-specifications-title').on('click',function(){
                    if($(this).hasClass('expand')){
                        $(this).removeClass('expand');
                        $(this).next().slideUp();
                        $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                        $(this).attr('aria-expanded', false);
                    } else {
                        $(this).addClass('expand');
                        $(this).next().slideDown();
                        $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
                        $(this).attr('aria-expanded', true);
                    }
                });
            }
        }

//console.log("documentWidth:" + documentWidth);

    } // sg9ExpandProductSpecifications()

    sg9ExpandProductSpecifications()

    if ( $('body').hasClass('template-product') ) { 



    }


    $('.faq-items__item-content').hide();

    $('.faq-items__item-title').on('click',function(){
        
        if($(this).hasClass('expand')){
            $(this).removeClass('expand');
            $(this).next().slideUp();
            $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
            $(this).attr('aria-expanded', false)
        
        } else {
            $(this).addClass('expand');
            $(this).next().slideDown();
            $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $(this).attr('aria-expanded', true)
        }

    });


    $('.custom-featured-photo').viewportChecker({    
        offset: -500    
    });



    $('.custom-featured-photo[data-video] > a > div').viewportChecker({    
        offset: -750,
        callbackFunction: function(elem, action){

            $dataVideoId = $(elem).parent().parent().attr('data-video');
            
            $(elem).append('<video autoplay="" loop="" muted="" playsinline=""><source id="mp4" src="' + $dataVideoId +'" type="video/mp4"></video>');
        }
    
    });


    //$('nav.header__inline-menu > ul > li:nth-child(6)').after('<li class="menu-lv-item menu-lv-1 has-megamenu dropdown block_layout--custom_width"><a href="/collections/halloween" class="menu-lv-1__action header__menu-item header__menu-item list-menu__item link link--text focus-inset"><span class="text link-effect">Halloween</span></a></li>');

/*
// Select the div
let triggerDiv = $('#block-image_7DixBd');
// Select the div


// Function to simulate hover (mouseenter and mouseleave)
function triggerHover() {
    triggerDiv.addClass('hover-active'); // Simulate mouse enter (hover)

    console.log("triggerHover add");

    setTimeout(function() {
        triggerDiv.removeClass('hover-active'); // Simulate mouse leave after a short time

        console.log("triggerHover remove");

    //}, 2500); // Adjust time (500 ms) for how long the hover effect should last
    }, 2500); // Adjust time (500 ms) for how long the hover effect should last


}

// Start triggering hover every 2 seconds
//let intervalId = setInterval(triggerHover, 5000);
let intervalId = setInterval(triggerHover, 5000);

// Stop triggering after 10 seconds (or any desired time)
setTimeout(function() {
    //clearInterval(intervalId);
}, 25000);
*/


// Select the div
if ($('#block-image_7DixBd').length) {
    
    let triggerDiv = $('#block-image_7DixBd');

    // Declare variables to store intervals and timeouts
    let intervalId;
    let hoverTimeout;

    // Function to simulate hover (mouseenter and mouseleave)
    function triggerHover() {
        triggerDiv.addClass('hover-active'); // Simulate mouse enter (hover)
        //console.log("triggerHover add");

        setTimeout(function() {
            triggerDiv.removeClass('hover-active'); // Simulate mouse leave after a short time
            //console.log("triggerHover remove");
        }, 2500); // Adjust time (2500 ms) for how long the hover effect should last
    }

    // Start triggering hover every 5 seconds
    intervalId = setInterval(triggerHover, 5000);

    // Stop hover simulation on actual hover
    triggerDiv.on('mouseenter', function() {
        clearInterval(intervalId); // Pause the hover simulation
        clearTimeout(hoverTimeout); // Clear any scheduled re-trigger
        triggerDiv.removeClass('hover-active'); // Clear 'hover-active' class immediately
        //console.log("Mouse entered, hover simulation paused");
    });

    // Resume hover simulation on mouse leave
    triggerDiv.on('mouseleave', function() {
        //console.log("Mouse left, scheduling hover simulation to resume");

        // Schedule hover simulation to resume after 2 seconds (or any desired time)
        hoverTimeout = setTimeout(function() {
            intervalId = setInterval(triggerHover, 5000); // Restart hover simulation
            //console.log("Hover simulation resumed");
        },  500);
    });

    // Stop triggering after 25 seconds (optional)
    setTimeout(function() {
        //clearInterval(intervalId); // Stop triggering hover
        //console.log("Hover simulation stopped after 25 seconds");
    }, 25000);

}



if ($('body').hasClass('b2b-custom')) {

    if ($('.b2b-location').length) { 

        $('.b2b-location').on('click', function(){

            $('.b2b-location').toggleClass('active');
            $('body').toggleClass('b2b-location-active');

        });


        // Select all anchor elements within the specified div
    $('.location-list a').each(function() {
        // Get the current href of the anchor element
        var currentHref = $(this).attr('href');
        
        // Create a URL object from the current href
        var url = new URL(currentHref);
        
        // Set the return_to parameter to the homepage
        url.searchParams.set('return_to', '/');
        
        // Update the href attribute with the modified URL
        $(this).attr('href', url.toString());
    });


    } // if .b2b-location lenght
}

if ($('body').hasClass('template-product')) {
        
    if ($('.productView-product .productView-quantity').hasClass('minimum-quantity-product')) {

        // Define minProdQty from the data attribute
        let minProdQty = Number($('.productView-product span[data-min-prod-qty]').data('min-prod-qty'));
        //console.log("minProdQty: " + minProdQty);


        // Function to update the subtotal
        function updateSubtotalFDP() {
            // Select the input element and get the quantity and data-price
            var $quantityInput1 = $('.productView-group .form-input.quantity__input');
            var quantity1 = parseInt($quantityInput1.val());
            var price1 = parseInt($quantityInput1.data('price'));

            // Calculate the subtotal
           var subtotalUpdate1 = quantity1 * price1;

            // Format subtotal to include a decimal point before the last two digits
            subtotalUpdate1 = subtotalUpdate1.toString().replace(/(\d+)(\d{2})$/, '$1.$2');

            // Update the subtotal element with the formatted subtotal
            $('.productView-subtotal .money').text(`$${subtotalUpdate1}`);
        }

        // Event listener to call updateSubtotalFDP function when quantity changes
        $('.productView-group .form-input.quantity__input').on('input', updateSubtotalFDP);

        // Initial call to set subtotal on page load
        updateSubtotalFDP();



        if (minProdQty !== undefined) {  
            if (!isNaN(minProdQty)) {   
                if ($('.productView-group .form-input.quantity__input').length) { 
                
                    $('.productView-group #product-add-to-cart, .productView-stickyCart #product-sticky-add-to-cart').off('click').on('click', function() {
                        // Retrieve the current quantity input value
                        let quantityInputValue = Number($('.productView-group .form-input.quantity__input').val());
                        
                        console.log("minProdQty: " + minProdQty);
                        console.log("quantityInputValue: " + quantityInputValue);

                        // Check if quantity meets the minimum requirement
                        if (minProdQty >= quantityInputValue) {
                            //console.log('The quantity matches the minimum required quantity.');
                            
                            setTimeout(function() {
                                $('.productView-product span[data-min-prod-qty]').removeClass('minimum-not-met');
                                $('.productView-group .form-input.quantity__input').val('1').attr('min', 1);
                                $('.productView-stickyCart .quantity__input').val('1').attr('min', 1);

                                updateSubtotalFDP();

                            }, 1000);
                        }
                        else if (minProdQty < quantityInputValue) {
                            //console.log('The quantity matches the minimum required quantity.');
                            
                            setTimeout(function() {
                                $('.productView-product span[data-min-prod-qty]').removeClass('minimum-not-met');
                                $('.productView-group .form-input.quantity__input').val('1').attr('min', 1);
                                $('.productView-stickyCart .quantity__input').val('1').attr('min', 1);

                                updateSubtotalFDP();

                            }, 1000);
                        } else {
                            //console.log('The quantity does not meet the minimum required quantity.');
                        }
                    });

                    // Get the value of input[name="id"] in .productView-buttons
                    const productId = $('.productView-product .productView-buttons input[name="id"]').val();
                    //console.log("productId: " + productId);

                    // Listen for a click event on elements with data-cart-remove-id in .halo-cart-sidebar
                    $('.halo-cart-sidebar').off('click', '[data-cart-remove-id]').on('click', '[data-cart-remove-id]', function() {
                        const cartRemoveId = $(this).data('cart-remove-id');

                        // Check if cartRemoveId matches productId
                        if (cartRemoveId == productId) {
                            //console.log('The cart item being removed matches the product ID in .productView-buttons');
                            
                            $('.productView-product span[data-min-prod-qty]').addClass('minimum-not-met');
                            $('.productView-group .form-input.quantity__input').val(minProdQty).attr('min', minProdQty);
                            $('.productView-stickyCart .quantity__input').val(minProdQty).attr('min', minProdQty);

                            updateSubtotalFDP();

                        }
                    });
                } // quantity length
            } // isNaN
        }
    } // minimum-quantity-product

    setTimeout(function() {

     
        $('.pl-swatches__color').each(function() {

            $(this).closest('a.pl-swatches__link').addClass('swatch-color');

            $('.pl-swatches__tooltip').each(function() {
                if ($(this).text().includes("Checkerboard White")) {
                    $(this).text('Checker-board White');
                }
                if ($(this).text().includes("Black/White Checkered")) {
                    //$(this).text('Checker-board White');
                    console.log("Black / White Checkered");
                }
            });
        })

        $('.pl-swatches__tooltip').each(function() {
            if ($(this).text().includes("Checkerboard White")) {
                $(this).text('Checker-board White');
            }
            if ($(this).text().includes("Black/White Checkered")) {
                //$(this).text('Checker-board White');
                //console.log("Black/White Checkered");
            }
        });
        

    }, 250);



} // template-product

/*
function sgFormatPrice() {

    setTimeout(() => {
        // Function to format price
        function formatPrice(price) {
            return `$${(price / 100).toFixed(2)}`;
        }

        // Iterate over each list item
        $('.previewCartItem').each(function() {
            // Get the data-price value
            const priceValue = $(this).find('.previewCartItem-price').data('price');
            if (priceValue) {
                // Format the price
                const formattedPrice = formatPrice(priceValue);

                // Output the result in the console
                console.log(`Formatted Price for Item: ${formattedPrice}`);

                // Update the text inside the .money element for the current item
                $(this).find('.previewCartItem-price .discounted-price .money').text(formattedPrice);
            }
        });
    }, 500);
    
}

// Initial run on page load
sgFormatPrice();

// Attach click event to #cart-icon-bubble
$('#cart-icon-bubble').on('click', function() {
    sgFormatPrice();
});

*/

if ($('body').hasClass('template-collection')) {



    $contentHeight = $('.collection-description').outerHeight(true);

    console.log("$contentHeight" + $contentHeight);

    //if ($contentHeight > 319) {
    if ($contentHeight > 319) {

        $('.collection-info-item .collection-description').after('<button class="button button--secondary"><span>Read More</span></button>');

        $('.collection-info-item .collection-description + button.button').on('click', function() {

            $('.collection-info-item .collection-description').css('max-height', '9999px');

            

            $('.collection-info-item .collection-description + button.button').remove();
        
            setTimeout(() => {
                $('.collection-description').addClass('remove-overflow');
                $('.collection-description').css('max-height', 'unset');
                
            }, 500);
        
        });

        
    } else {

        $('.collection-info-item .collection-description').addClass('remove-overflow');

    }

    
    
}

    function sgFixedFilter() {
        var topFDPHeader = false;

        if ($('body').hasClass('template-collection')) {
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            var $sidebar = $('#halo-sidebar');
            
            if ($filterElement.length) {
                var filterTop = $filterElement.offset().top;
                var sidebarHeight = $sidebar.length ? $sidebar.outerHeight() : 0;
                
                $(window).on('scroll', function() {
                    var scrollTop = $(window).scrollTop();
                    var offset = (typeof topFDPHeader !== 'undefined' && topFDPHeader === false) ? 0 : 111;
                    
                    // Check if scroll reached the element (top + offset)
                    if (scrollTop >= (filterTop - offset)) {
                        $('body').addClass('filter-fixed-scrolling');
                        // Set top inline based on sidebar height
                        $filterElement.css('top', sidebarHeight + 'px');
                    } else {
                        $('body').removeClass('filter-fixed-scrolling');
                        $filterElement.css('top', '');
                    }
                });

                // Update offset and sidebar height on resize
                $(window).on('resize', function() {
                    if ($sidebar.length) {
                        sidebarHeight = $sidebar.outerHeight();
                    }
                    
                    if (!$('body').hasClass('filter-fixed-scrolling')) {
                        filterTop = $filterElement.offset().top;
                    } else {
                        // If currently fixed, update the top position dynamically
                        $filterElement.css('top', sidebarHeight + 'px');
                    }
                });
            }
        }
    }
    sgFixedFilter();

    function sgFixedFilterMobile() {
        if ($('body').hasClass('template-collection')) {
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            var $toolbarElement = $('#CollectionProductGrid toolbar-item.toolbar');

            if ($filterElement.length && $toolbarElement.length) {
                
                var filterTop = $('#CollectionProductGrid').offset().top - 75;

                $(window).on('scroll', function() {
                    var scrollTop = $(window).scrollTop();
                    
                    if (scrollTop >= filterTop) {
                        $('body').addClass('filter-mobile-fixed-scrolling');
                    } else {
                        $('body').removeClass('filter-mobile-fixed-scrolling');
                    }
                });

                $(window).on('resize', function() {
                    if (!$('body').hasClass('filter-mobile-fixed-scrolling')) {
                        filterTop = $('#CollectionProductGrid').offset().top - 75;
                    }
                });
            }
        }
    }
    sgFixedFilterMobile();

}) // document ready
